import * as constance from "../constance/action.constance";

const isLoading = (isLoading) =>{
    return {
        type:constance.LOADER,
        payload:isLoading
    }
}

export {isLoading}